import { render, staticRenderFns } from "./DashboardResume.vue?vue&type=template&id=5cf9894f&"
import script from "./DashboardResume.vue?vue&type=script&lang=js&"
export * from "./DashboardResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cf9894f')) {
      api.createRecord('5cf9894f', component.options)
    } else {
      api.reload('5cf9894f', component.options)
    }
    module.hot.accept("./DashboardResume.vue?vue&type=template&id=5cf9894f&", function () {
      api.rerender('5cf9894f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/dashboard/DashboardResume.vue"
export default component.exports